export const classes = {
  divider: 'my-4',
};
